function mapTheme(appearance) {
  switch (appearance) {
    case 'error':
      return {
        textColor: 'text-red-500',
        iconBorderColor: 'border-red-100',
        buttonAppearance: 'danger'
      };

    case 'info':
      return {
        textColor: 'text-blue-500',
        iconBorderColor: 'border-blue-100',
        buttonAppearance: 'primary'
      };

    case 'success':
      return {
        textColor: 'text-green-500',
        iconBorderColor: 'border-green-100',
        buttonAppearance: 'success'
      };

    case 'warning':
    default:
      return {
        textColor: 'text-orange-500',
        iconBorderColor: 'border-orange-100',
        buttonAppearance: 'warning'
      };
  }
}

export default mapTheme;
//# sourceMappingURL=styles.esm.js.map
